import { ChangeDetectorRef, Component } from '@angular/core';
import { UUID } from 'angular2-uuid';
import moment from 'moment';
import { AProgessBarWizardComponent } from '../../../components/common/progressbarwizard/iprogressbar.wizard.component';
import { ProgressBarWizardEvents } from '../../../components/common/progressbarwizard/progressbar.wizard.events';
import { NotificationLevel } from '../../../models/enums/notificationlevel.enum';
import { SmartSyncService } from '../../../services/smart.sync.service';
import { WebsocketService } from '../../../services/websocket.service';

@Component({
    selector: 'siw-finish-page',
    templateUrl: './siw.finish.page.html',
    styleUrls: ['./siw.finish.page.css']
})
export class SmartIntegrationWizardFinishPage extends AProgessBarWizardComponent {
    DataSourceCaption: string;
    UseCaseCaption: string;
    Tables = [];
    FilterTables = [];
    SuccessRowHidden = false;
    SaveRunning = false;
    ImportRunning = false;
    SaveResult: any;
    ImportResult: any;

    constructor(private cdRef: ChangeDetectorRef, private service: SmartSyncService) {
        super();
    }

    OnWizardStateSet(): void {
        if (this.WizardState) {
            if (this.WizardState.SelectedDataSource) {
                this.DataSourceCaption = this.WizardState.SelectedDataSource.Caption;
            }
            if (this.WizardState.SelectedUseCase) {
                this.UseCaseCaption = this.WizardState.SelectedUseCase.Caption;
                if (this.WizardState.LoadedUseCases) {
                    const useCase = this.WizardState.LoadedUseCases[this.WizardState.SelectedUseCase.ID];
                    if (useCase && useCase.Tables) {
                        useCase.Tables.forEach((t: any) => {
                            if (t.Fields) {
                                const fields = [];
                                const filterFields = [];
                                t.Fields.forEach((f: any) => {
                                    if (f.Selected) {
                                        fields.push(f.TranslatedCaption);
                                    }
                                    if (f.CanBeFiltered && f.FilterValue) {
                                        if (f.DataTyp == "System.DateTime") {
                                            if (f.FilterValue.From == null) {
                                                if (f.FilterValue.To != null) {
                                                    const filter = f.TranslatedCaption + '<= ' + moment(f.FilterValue.To).format('lll');
                                                    filterFields.push(filter);
                                                }
                                            } else {
                                                if (f.FilterValue.To == null) {
                                                    const filter = f.TranslatedCaption + '>= ' + moment(f.FilterValue.From).format('lll');
                                                    filterFields.push(filter);
                                                } else {
                                                    const filter = f.TranslatedCaption + ': ' + moment(f.FilterValue.From).format('lll') +
                                                        ' <> ' + moment(f.FilterValue.To).format('lll');
                                                    filterFields.push(filter);
                                                }
                                            }                                            
                                        } else if (f.FilterValue.Values && f.FilterValue.Values.length > 0) {
                                            if (f.FilterValue.Values.length == 1) {
                                                filterFields.push(f.TranslatedCaption + ' = ' + f.FilterValue.Values[0]);
                                            } else if (f.FilterValue.Values.length > 1) {
                                                filterFields.push(f.TranslatedCaption + ' in (' + f.FilterValue.Values.join(', ') + ')');
                                            }
                                        }
                                    }
                                });
                                if (fields.length > 0) {
                                    this.Tables.push({
                                        Caption: t.TranslatedCaption,
                                        Fields: fields
                                    });
                                }
                                if (filterFields.length > 0) {
                                    this.FilterTables.push({
                                        Caption: t.TranslatedCaption,
                                        Fields: filterFields
                                    });
                                }
                            }
                        });
                    }
                }
            }
            this.cdRef.detectChanges();
        }
    }

    goTo(index: number) {
        ProgressBarWizardEvents.GoTo.next(index);
    }

    startImport() {
        if (this.WizardState && this.WizardState.SelectedDataSource && this.WizardState.SelectedUseCase
            && this.WizardState.SelectedTarget && this.WizardState.TargetTableName && this.WizardState.LoadedUseCases) {
            const useCase = this.WizardState.LoadedUseCases[this.WizardState.SelectedUseCase.ID];
            if (useCase) {
                const query = {
                    Channel: UUID.UUID(),
                    TargetDataSource: this.WizardState.SelectedTarget,
                    TableName: this.WizardState.TargetTableName,
                    SourceDataSource: this.WizardState.SelectedDataSource.Id,
                    UseCaseID: this.WizardState.SelectedUseCase.ID,
                    Tables: []
                };
                useCase.Tables.forEach((t: any) => {
                    const table = {
                        Name: t.Name,
                        Schema: t.Schema,
                        Fields: []
                    };
                    t.Fields.forEach((f: any) => {
                        const field = {
                            Name: f.Name,
                            Filter: null
                        };
                        if (f.CanBeFiltered && f.FilterValue) {
                            if (f.DataTyp == "System.DateTime") {
                                if (f.FilterValue.From != null || f.FilterValue.To != null) {
                                    field.Filter = {
                                        OnlyFilter: !f.Selected,
                                        From: f.FilterValue.From,
                                        To: f.FilterValue.To
                                    };
                                }
                            } else if (f.FilterValue.Values.length > 0) {
                                field.Filter = {
                                    OnlyFilter: !f.Selected,
                                    FilterValues: f.FilterValue.Values
                                };
                            }
                        }
                        if (f.Selected || field.Filter) {
                            table.Fields.push(field);
                        }
                    });
                    if (table.Fields.length > 0) {
                        query.Tables.push(table);
                    }
                });
                WebsocketService.WaitForWebSocketService().then(() => {
                    const subScription = WebsocketService.MessageReceived.subscribe((response) => {
                        const parsed = JSON.parse(response);
                        if (parsed.Level === NotificationLevel.System &&
                            parsed.Channels && parsed.Channels.some((x: any) => x === query.Channel) &&
                            parsed.Type === 'evidanza.MiddleWare.Shared.Integration.SmartSync.SmartSyncWorkerInfo') {
                            subScription.unsubscribe();
                            WebsocketService.Unsubscribe([{ Channel: query.Channel, Level: [0] }]);
                            this.ImportRunning = false;
                            this.ImportResult = JSON.parse(parsed.Content);
                            this.cdRef.detectChanges();
                        }
                    });
                    WebsocketService.Subscribe([{ Channel: query.Channel, Level: [0] }]).then(() => {
                        this.service.SaveAndStartUseCase(query).subscribe((x: any) => {
                            this.SaveRunning = false;
                            this.SaveResult = x;
                            if (x && x.SuccessfullyCreatedTable) {
                                this.ImportRunning = true;
                            } else {
                                subScription.unsubscribe();
                                WebsocketService.Unsubscribe([{ Channel: query.Channel, Level: [0] }]);
                            }
                            this.cdRef.detectChanges();
                        });
                    });
                });
                this.SaveRunning = true;
                this.cdRef.detectChanges();
                ProgressBarWizardEvents.ShowButtons.next(false);
            }
        }
    }

    closeWizard() {
        ProgressBarWizardEvents.CloseWizard.next();
    }
}
